export default {
	title: 'Fishbone',
	subtitle:
		'Strategic implementations require a holistic approach to be successful. The main drivers of your success are represented by each bone, the sub-bones shall show the related measures',
}
